import { clearSkinini } from "@services/storage/skinini";
import { openDialog } from "@components/dialog";
import { downloadSkinini } from "@services/download/download";
import { $$ } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";

/**
 * Handle reset ini button click
 * Shows confirmation dialog, on confirm clears skinini and reloads page
 */
async function handleResetIni(): Promise<void> {
  const result = await openDialog("resetSkininiDialog");

  if (result === "confirm") {
    clearSkinini();
    location.reload();
  }
}

/**
 * Handle import ini button click
 * Placeholder - will be implemented later
 */
function handleImportIni(): void {
  // TODO: Implement import functionality
}

/**
 * Handle download ini button click
 * Downloads skinini as a zip file
 */
async function handleDownloadIni(): Promise<void> {
  try {
    await downloadSkinini();
  } catch (error) {
    console.error("Download failed:", error);
  }
}

/**
 * Initialize skinini options functionality
 * Attaches click handlers to all option buttons (desktop and mobile)
 */
export function initSkininiOptions(): void {
  // Reset ini buttons
  const resetButtons = $$(DATA_ATTR.RESET_INI);
  resetButtons.forEach((button) => {
    button.addEventListener("click", handleResetIni);
  });

  // Import ini buttons
  const importButtons = $$(DATA_ATTR.IMPORT_INI);
  importButtons.forEach((button) => {
    button.addEventListener("click", handleImportIni);
  });

  // Download ini buttons
  const downloadButtons = $$(DATA_ATTR.DOWNLOAD_INI);
  downloadButtons.forEach((button) => {
    button.addEventListener("click", handleDownloadIni);
  });
}
